import { language as lan_inactivePartnerTip } from "./inactive-partner-tip";
import { language as lan_storeProdutFilter } from "./store-product-filter";
import { language as lan_storeProdutList } from "./store-product-list";
import { language as lan_emptyStoreTip } from "./empty-store-tip";
import { language as lan_emptyStoreProducTip } from "./empty-store-product-tip";

let language = {
    // 合作伙伴激活提示
    ...lan_inactivePartnerTip,
    // 店铺产品过滤条件
    ...lan_storeProdutFilter,
    // 店铺产品列表
    ...lan_storeProdutList,
    // 空店铺提示
    ...lan_emptyStoreTip,
    // 空店铺产品提示
    ...lan_emptyStoreProducTip,
    // 禁止添加店铺产品提示
    STORE_PRODUCT_UNSUPPORTED_PRODUCT_TIP_TITLE: "不支持的产品",
    STORE_PRODUCT_UNSUPPORTED_PRODUCT_TIP_DES: "抱歉，该店铺不支持添加店铺产品。",
    // 店铺产品更新成功-询问用户是否需要不同步店铺产品
    STORE_PRODUCT_UPDATE_SUCCEED_TIP_TITLE: "店铺产品更新成功",
    STORE_PRODUCT_UPDATE_SUCCEED_TIP_DES: "您已成功更新店铺产品。接下来，您可以将此产品同步到您的在线 E-Shop。点击 [同步] 立即同步，或点击 [稍后] 稍后同步。",
    // 店铺产品同步提示
    STORE_PRODUCT_SYNCHRONIZED_TITLE: "存在已同步店铺产品",
    STORE_PRODUCT_SYNCHRONIZED_CONTENT: "您当前选择的选中项存在已完成同步的产品，需要过滤已同步的产品吗？",
    // 店铺不属于partner 
    STORE_PRODUCT_MISMATCH_STORE_TITLE: "商店不匹配合作伙伴",
    STORE_PRODUCT_MISMATCH_STORE_CONTENT: "当前的商店似乎不属于当前的合作伙伴。",
};

export { language }
